import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';


const product = [
    { product: 'Virtual Office Plain Package'},
    { product: 'Virtual Office Public Package'},
    { product: 'Virtual Office Premium Package'},
    { product: 'Virtual Office Preestige Package'},
    { product: 'Private Office'},
    { product: 'Pendirian PT'},
    { product: 'Pendirian CV'},
    { product: 'Meeting Room'},
  ];

export default function CreatePost(){

    const [user_name,setUserName] = useState("")
    const [post,setPost] = useState("")
    const [Likes,setLikes] = useState("")
    const [Caption,setCaption] = useState("")

    async function tambahPost(e){
        e.preventDefault()

        try{
        const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/createpost`,{
            user_name, post, Likes, Caption
        });
        setUserName("")
        setPost("")
        setLikes("")
        setCaption("")
        console.log("berhasil")
        }catch(error){
        console.log("error")
    };}

    return <Grid container>
                <Grid item xl={1.2} lg={1.9} md={2.6} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid item xl={10.8} lg={10.1} md={9.4} sm={8.8}>
                    <Grid className="boxshadowclass">
                        <Header></Header>
                    </Grid>
                    <Grid>
                    <form onSubmit={tambahPost}>
                    <Grid sx={{ mt:10, ml:10 }}>
                        <TextField value={user_name} label="User Name" onChange={(e) => setUserName(e.target.value)}></TextField>
                        <div>
                            <h1>Upload and Display Image usign React Hook's</h1>
                            {post && (
                                <div>
                                <img alt="not fount" width={"250px"} src={URL.createObjectURL(post)} />
                                <br />
                                <button onClick={()=>setPost(null)}>Remove</button>
                                </div>
                            )}
                            <br />
                            
                            <br /> 
                            <input
                                type="file"
                                name="myImage"
                                onChange={(event) => {
                                console.log(event.target.files[0]);
                                setPost(event.target.files[0]);
                                }}
                            />
                        </div>
                        <TextField value={Likes} label="Likes" onChange={(e) => setLikes(e.target.value)}></TextField>
                        <TextField value={Caption} label="Caption" onChange={(e) => setCaption(e.target.value)}></TextField>

                        <Button sx={{ mt: 2 }} type="submit" variant="contained">Tambah Alamat</Button>
                    </Grid>
                    </form>
                    </Grid>
                </Grid>    
            </Grid>
    };